<template>
  <div>
    <p class="title text-left">喜报！上海及时雨小贷斩获“全国优秀小贷”荣誉</p>
    <p class="desc text-left">2019-1-17　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">近日，从中国小额贷款公司协会传来喜讯，在2018年度全国优秀小额贷款公司的评选活动中，上海嘉定及时雨小额贷款股份有限公司荣获“全国优秀小额贷款公司”。</p>
      <div class="normal"><img src="../img/newsDetail/3-01.png" width="100%" alt=""></div>
      <p class="normal">全国优秀小额贷款公司推介活动（2018）”是由中国小额贷款公司协会组织，依托地方协会专门委员会开展的全国范围小贷行业评优活动。本次评选范围共有全国9000多家小贷公司，最终只有317家小贷公司入围，其中上海仅有3家小额贷款公司获此殊荣。</p>
      <p class="normal">上海嘉定及时雨小额贷款股份有限公司是经上海市政府批准设立的专业融资机构，注册资本金1亿元。公司自开业以来，一直坚持“小额、分散”的经营原则，严格按照现代企业制度进行管理，构建了运行规范、权责清晰的公司管理体系。</p>
      <p class="normal">及时雨自成立以来，始终坚持线上线下相结合的风控理念，凭借专业的管理团队、先进的经营理念、丰富的行业经验、成熟的运作模式和创新的产品服务，专注于微型金融业务市场，努力为本市的小企业，个体工商户提供专业、全面的小额信贷服务。</p>
      <p class="normal">未来也会尊重金融本质、遵循道德规范，继续为广大借款人提供更优质的服务！</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsDetail3"
  }
</script>

<style scoped lang="less">
  @import "newsDetail.less";
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail3.vue